
import styled from 'styled-components';
import Label from '../../element/ui/core/label';

const StyledTabs = styled.div`
  padding: 0 12px 12px 0;
  overflow-y: auto;
  max-height: 100%;

  [data-phone='true'] & {
    display: flex;
    padding: 0;
  }
`;

// Chrome (size, colors, square shape) lives in editor.scss — .respark_tab
const StyledTabItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 0;

  &,
  * {
    cursor: pointer;
  }

  [data-phone='true'] & {
    border-radius: 0;
  }
`;

const StyledTabItemLabel = styled(Label)`
  margin: 0;
  text-align: center;
`;

export { StyledTabs, StyledTabItem, StyledTabItemLabel };
